import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import ContactForm from "../forms/contactForm";
import CtaOffer from "../common/ctaOffer";

function Offer1Ekspertyzy() {
  return (
    <>
      {/* HERO */}
      <section className="relative overflow-x-hidden flex flex-col lg:flex-row items-center justify-between lg:min-h-[60vh] p-6 lg:px-12 lg:pt-48 lg:pb-36 gap-6">
        <img
          className="absolute w-full h-full object-cover z-10 top-0 left-0"
          src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/ekspertyzy-Duzy.jpeg"
          alt="Inwentaryzacja drzew i krzewów - ekspertyzy dendrologiczne - Drzewus"
        />
        <div className="w-full h-full object-cover z-20 absolute top-0 left-0 gradient-green-ltr"></div>
        <div className="flex flex-col items-start justify-center gap-2 z-30">
          <h1 className="text-3xl lg:text-6xl text-white text-left">
            Ekspertyzy dendrologiczne i ocena stanu drzew Gdańsk, Gdynia, Kaszuby
          </h1>
          <h2 className="text-xl lg:text-3xl text-white text-left">
            Profesjonalna inwentaryzacja zieleni pod inwestycje
          </h2>
          <p className="text-white text-base lg:text-xl max-w-[850px] text-left">
            Planujesz budowę domu lub inwestycję na terenie Gdańska, Gdyni, Wejherowa lub Kartuz i potrzebujesz zgody na wycinkę? DRZEWUS wykonuje rzetelne ekspertyzy dendrologiczne oraz inwentaryzacje zieleni na Kaszubach i w całym województwie pomorskim. Nasza ocena stanu zdrowotnego drzew pomaga w uzyskaniu formalnych pozwoleń oraz zaplanowaniu prac takich jak <a href="/oczyszczanie-terenu/karczowanie-drzew" className="underline hover:opacity-80">karczowanie działek</a> czy <a href="/oczyszczanie-terenu/niewelacja-terenu" className="underline hover:opacity-80">niwelacja terenu</a> pod przyszłą budowę.
          </p>
          <a href="#wiecej">
            <button className="button-yellow">Dowiedz się więcej</button>
          </a>
        </div>
        <div className="z-30 max-w-[500px] flex flex-col items-center justify-center">
          {" "}
          <ContactForm />
        </div>
      </section>
      {/* CONTENT */}
      <section
        id="wiecej"
        className="p-6 lg:px-24 lg:py-12 grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-12"
      >
        <div className="lg:col-span-1 flex flex-col gap-6">
          <div className="flex flex-col gap-2 p-6 rounded-xl bg-green w-full">
            <a
              href="#1"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Inwentaryzacja dendrologiczna
            </a>
            <a
              href="#2"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Inwentaryzacja drzew i krzewów
            </a>

            <a
              href="#3"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Specjalista dendrologiczny do wynajęcia
            </a>
            <a
              href="#4"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Inwentaryzacja zieleni, opinie i ekspertyzy
            </a>
            <a
              href="#5"
              className="py-2 px-6 w-full bg-white rounded-xl hover:bg-[#EEB442] transition duration-300 ease-linear color-green hover:text-white text-left text-lg"
            >
              Inwentaryzacja przyrodnicza przed inwestycją
            </a>
          </div>
          <CtaOffer />
        </div>
        <div className="lg:col-span-2 flex flex-col items-start justify-start text-left gap-2 content-offer">
          <h2 id="1">Inwentaryzacja dendrologiczna</h2>
          <p>
            Inwentaryzacja dendrologiczna to dość żmudny i pracochłonny proces,
            ale dzięki naszemu doświadczeniu jesteśmy w stanie zrobić to szybko
            i sprawnie. Przygotowujemy też opinie i ekspertyzy dendrologiczne
            oraz ornitologiczne. Pomagamy w uzyskaniu pozwoleń na usunięcie
            drzew oraz zajmujemy się wycinką i nasadzeniami. Kompleksowo dbamy o
            tereny zielone.
          </p>
          <h2 id="2">Inwentaryzacja drzew i krzewów</h2>
          <p>
            Inwentaryzacja drzew i krzewów jest też znana jako inwentaryzacja
            zieleni. Najczęściej jest potrzebna do złożenia wniosku o wycinkę
            drzew. Może też przydać się przy planowaniu inwestycji. Taką
            inwentaryzację wykonuje się wtedy, gdy rosnące na działce drzewa i
            krzewy kolidują z zaplanowanymi zabudowaniami.
          </p>
          <p>
            Przed rozpoczęciem inwestycji architekt przygotowuje projekt
            zagospodarowania terenu. W niektórych przypadkach niezbędne jest też
            przygotowanie dokumentacji koniecznej do uzyskania decyzji
            środowiskowej. Może obejmować ona przesadzenie lub wycinkę drzew i
            krzewów przed przystąpieniem do prac budowlanych.
          </p>
          <p>
            W takim wypadku trzeba sporządzić inwentaryzację drzew i krzewów.
            Może to być jeden z wymogów niezbędnych do wydania decyzji
            środowiskowej. Taka decyzja jest konieczna, jeśli jako inwestor
            będziesz zmieniał lokalizację zieleni na działce lub zdecydujesz się
            na wycinkę niektórych drzew. Usunięcie drzew zleć nam, bo wykonujemy
            również takie usługi.
          </p>
          <p>
            Zmiana lokalizacji wiąże się z przesadzeniem drzew lub krzewów.
            Natomiast ich wycinka często związana jest z obowiązkiem dokonania
            nasadzeń zastępczych. W takiej sytuacji niezbędny jest projekt
            nasadzeń. Możemy taki projekt wykonać dla Ciebie, a potem
            zrealizować potrzebne nasadzenia.
          </p>
          <h2 id="3">Specjalista dendrologiczny do wynajęcia</h2>
          <p>
            Tak zwana inwentaryzacja zieleni, czyli inwentaryzacja
            dendrologiczna sporządzana jest, żeby określić rodzaj oraz ilość
            drzew i krzewów na terenie inwestycji. Wskazuje ich rozmieszczenie
            na działce, a także parametry dendrometryczne, takie jak:
          </p>
          <ul>
            <li>wysokość</li>
            <li>obwód pnia, </li>
            <li>zasięg korony,</li>
            <li>zajmowaną powierzchnię,</li>
            <li>uwagi o stanie zdrowia danego drzewa lub krzewu.</li>
          </ul>
          <p>
            Wszystko to wykonuje nasz specjalista, dzięki czemu uzyskanie
            pozwolenia na wycinkę lub decyzji o uwarunkowaniach środowiskowych
            nie będzie stanowić problemu. Warto przy tym pamiętać, że
            inwentaryzacja dendrologiczna ważna jest przez pół roku. Jest tak
            dlatego, że drzewa i krzewy cały czas rosną, więc warto zaplanować
            sporządzenie takiej inwentaryzacji w odpowiednim czasie.
          </p>
          <h3 id="4">Inwentaryzacja zieleni, opinie i ekspertyzy</h3>
          <p>
            Wykonamy dla Ciebie kompleksową inwentaryzację dendrologiczną. Taka
            dokumentacja jest potrzebna między innymi do uzyskania decyzji
            administracyjnej wraz z pozwoleniem na wycinkę drzew.
          </p>
          <p>
            Korzystając z naszych usług otrzymasz od nas kompletną dokumentację,
            dzięki której możesz zoptymalizować koszty opłat administracyjnych
            za wycinkę, a w niektórych przypadkach nawet całkowicie ich uniknąć.
          </p>
          <p>
            Wykonujemy też projekty gospodarki drzewostanem. Takie opracowanie
            jest sporządzone zarówno w formie opisowej, tabelarycznej, jak i
            graficznej. Jest ono zawsze zgodne z obowiązującymi przepisami i
            najnowszą wiedzą z zakresu dendrologii.
          </p>
          <p>
            Dzięki naszej usłudze otrzymasz rzetelne informacje, które drzewa z
            terenu inwestycji wymagają usunięcia ze względu na zagrożenie dla
            bezpieczeństwa mienia i ludzi. Wskażemy też, które drzewa kolidują z
            projektowanym zagospodarowaniem terenu inwestycji. Podpowiemy
            również, które drzewa warto ochronić i zachować w czasie inwestycji,
            by zyskać lepszy wygląd działki.
          </p>
          <p>
            Częścią opinii dendrologicznej może być również wyliczenie opłat za
            usunięcie drzew i krzewów, a także sporządzenie projektu nasadzeń
            zastępczych wraz z szacowanym kosztem ich wykonania. Zarówno wycinkę
            drzew, jak i nasadzenia zleć naszej firmie, a zajmiemy się tym
            kompleksowo.
          </p>
          <h3 id="5">Inwentaryzacja przyrodnicza przed inwestycją</h3>
          <p>
            Przy inwestycjach wielkoobszarowych dobrą praktyką jest sporządzenie
            inwentaryzacji przyrodniczej. Jednym z jej elementów jest
            inwentaryzacja zieleni. Pominięcie tego etapu może skutkować
            opóźnieniem lub nawet odmową wydania decyzji środowiskowej.
          </p>
          <p>
            Z tego względu najlepiej powierzyć to zadanie nam. Sporządziliśmy
            już wiele takich inwentaryzacji, które okazały się niezbędne do
            uzyskania zezwolenia na dalsze prace przy inwestycjach.
          </p>
          <p>
            Nasza firma może pomóc Ci na każdym etapie inwestycji. Działamy
            kompleksowo i zajmujemy się oczyszczaniem terenu pod inwestycje,
            wycinką drzew i krzewów, niwelacją terenu, frezowaniem pni, a także
            zakładaniem ogrodów i trawników wraz z nawadnianiem.
          </p>
          <p>
            Wykonamy dla Ciebie opis oraz pomiar drzewostanu, spis gatunkowy
            drzew na danym terenie wraz z oceną ich stanu zdrowotnego.
          </p>
          <p>
            Jeśli potrzebujesz inwentaryzacji dendrologicznej, to jesteś w
            dobrym miejscu. Nasza firma wykona dla Ciebie taką inwentaryzację.
            Jedyne co musisz zrobić, to wypełnić formularz.
          </p>
        </div>
      </section>
      {/* PORTFOLIO */}
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col lg:flex-row items-start justify-start lg:items-center lg:justify-between gap-6 lg:gap-24">
          <div className="flex flex-col items-start justify-start gap-2 w-full">
            {" "}
            <h2 className="uppercase color-yellow text-xl">Nasze realizacje</h2>
            <h3 className="text-3xl lg:text-5xl color-green text-left">
              Spójrz jak pomogliśmy<br></br>
              <span className="color-yellow">naszym Klientom</span>
            </h3>
          </div>
          <div className="flex flex-col items-start justify-center w-full lg:w-2/3">
            <p className="text-gray-600 text-left">
              Oto przykłady naszych realizacji, w których zadbaliśmy o bezpieczeństwo i stan zdrowotny drzewostanu. Od lat wspieramy inwestorów oraz osoby prywatne w profesjonalnej inwentaryzacji zieleni i pracach arborystycznych.
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/realizacja-1.jpg"
              alt="Inwentaryzacja zieleni - realizacja Drzewus nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-3">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/Realizacja-2.jpg"
              alt="Inwentaryzacja zieleni - realizacja Drzewus nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-4.png"
              alt="Inwentaryzacja zieleni - realizacja Drzewus nr 3"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/realizacja-4.jpg"
              alt="Inwentaryzacja zieleni - realizacja Drzewus nr 4"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2025/02/Realizacja-1.jpg"
              alt="Inwentaryzacja zieleni - realizacja Drzewus nr 5"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
      </section>
      {/* <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="flex flex-col items-center justify-center mb-6">
          <h2 className="uppercase color-yellow text-xl text-center">
            Nasze realizacje
          </h2>
          <h3 className="text-3xl lg:text-5xl color-green text-center">
            Spójrz jak pomogliśmy<br></br>
            <span className="color-yellow">naszym Klientom</span>
          </h3>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-1.png"
              alt="Portfolio Drzewus nr 1"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-2.png"
              alt="Portfolio Drzewus nr 2"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-3.png"
              alt="Portfolio Drzewus nr 3"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-4.png"
              alt="Portfolio Drzewus nr 4"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-1">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-5.png"
              alt="Portfolio Drzewus nr 5"
              className="h-full object-cover w-full"
            />
          </div>
          <div className="rounded-xl relative overflow-hidden flex flex-col items-center justify-center h-[300px] lg:col-span-2">
            <img
              src="https://magazyn.drzewus.pl/wp-content/uploads/2024/10/home-portfolio-6.png"
              alt="Portfolio Drzewus nr 6"
              className="h-full object-cover w-full"
            />
          </div>
        </div>
      </section> */}
    </>
  );
}

export default Offer1Ekspertyzy;
